import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-produse',
  templateUrl: './produse.component.html',
  styleUrls: ['./produse.component.css']
})
export class ProduseComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
